import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class MainDashboardService {
  constructor(public http: HttpClient) {}

  private url = environment.apiUrl;

  getGradeManagementCount() {
    return this.http.get(`${this.url}Classes/GetCounts`);
  }
}
